import { useState, useEffect } from 'react';
import { useCurrentUser } from '@/shared/hooks/useCurrentUser';
import { inventoryStockOutService } from '../services/inventoryStockOut.service';
import type { InventoryStockOutFormValues, InventoryStockOutItem } from '../types/inventoryStockOut.types';

const defaultValues: InventoryStockOutFormValues = {
  quantity: 0,
  transaction_date: new Date().toISOString().split('T')[0],
  note: '',
};

export function useInventoryStockOut(id: string) {
  const { user } = useCurrentUser();
  const [item, setItem] = useState<InventoryStockOutItem | null>(null);
  const [values, setValues] = useState<InventoryStockOutFormValues>(defaultValues);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    async function init() {
      if (!id || !user.companyId) return;
      try {
        setIsLoading(true);
        const data = await inventoryStockOutService.getStockOutItem(id, user.companyId);
        setItem(data);
      } catch (error) {
        console.error('[useInventoryStockOut] init error:', error);
      } finally {
        setIsLoading(false);
      }
    }
    init();
  }, [id, user.companyId]);

  const submitStockOut = async () => {
    if (!user.companyId || !user.id || !item) return false;
    if (values.quantity <= 0) {
      alert('S lng xut phi ln hn 0');
      return false;
    }
    if (values.quantity > item.current_stock) {
      alert('S lng xut vt qu tồn kho hin ti');
      return false;
    }

    setIsSaving(true);
    try {
      await inventoryStockOutService.createStockOut({
        inventory_item_id: item.id,
        quantity: values.quantity,
        transaction_date: values.transaction_date,
        type: 'stock_out',
        note: values.note,
        company_id: user.companyId,
        created_by: user.id,
        project_id: values.project_id || null,
        work_order_id: values.work_order_id || null,
        team_id: values.team_id || null,
      });
      return true;
    } catch (error: any) {
      console.error('[useInventoryStockOut] submitStockOut error:', error);
      alert(error.message || 'C li xy ra khi xut kho. Vui lng th li.');
      return false;
    } finally {
      setIsSaving(false);
    }
  };

  return {
    item,
    values,
    setValues,
    isLoading,
    isSaving,
    submitStockOut,
    remainingStock: item ? item.current_stock - (values.quantity || 0) : 0,
  };
}
